/**
 * This file contains all PostHog event names and their properties
 * using the category:object_action naming convention.
 */

/**
 * Helper function to create a versioned event name
 * @param name Base event name
 * @param version Version number (optional, defaults to 1)
 * @returns Versioned event name (e.g. "event:name" or "event:name_v2")
 */
function v(name: string, version: number = 1): string {
	return version === 1 ? name : `${name}_v${version}`
}

export const EVENTS = {
	// Profile Events
	PROFILE: {
		CREATE: v('profile:create'),
		VIEW: v('profile:view'),
		UPDATE: v('profile:update'),
	},
	// Map Events
	MAP: {
		MARKER_CLICK: v('map:marker_click'),
		ZOOM: v('map:zoom'),
	},
	// Auth Events
	AUTH: {
		LOGIN_START: v('auth:login_start'),
		LOGIN_SUCCESS: v('auth:login_success'),
		LOGOUT: v('auth:logout'),
	},
	// Share Events
	SHARE: {
		DRAWER_OPEN: v('share:drawer_open'),
		TWITTER_CLICK: v('share:twitter_click'),
		LINK_COPY: v('share:link_copy'),
	},
} as const
